<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-10">
                    <MultiSelect
                        v-model="filter.search"
                        :options="options.nopol.map(x => x.nopol)"
                        :multiple="false"
                        placeholder="Masukkan Nomor Polisi"
                        class="elegant-multiselect no-caret"
                        :internal-search="false"
                        @search-change="debounceFunction"
                    />
                </div>
                <div 
                    class="col-md-2 text-right" 
                    style="display: flex; justify-content: flex-end">
                    <button
                        class="btn"
                        type="button"
                        style="
                            background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold; 
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">
            <!-- Title & Option Buttons Start -->
            <div class="row">
                <div class="col-md-3">
                    <!-- <button 
                        class="btn btn--mpm--transporter"
                        style="
                            background-color: #1B698E; 
                            color: white;
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"    
                    >Export XL</button> -->
                </div>
                <div class="mb-4 col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins;">Report Tracking</h3>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-4">
                    <div class="d-flex">
                        <div 
                            class="col-4 ml-2" 
                            style="
                                display: flex; 
                                align-items: center; 
                                font: normal normal 12px/21px Poppins;"
                        ><span style="font: normal normal 12px/21px Poppins;">Filter Tanggal</span>
                        </div>
                        <div class="col-8">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="selected.date"
                                style="font: normal normal normal 12px/18px Poppins;"
                            ></flat-pickr>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Title & Option Buttons End -->
            
            <vue-universal-table
                api_url="/api/reports/tracking-report"
                :filter="filter"
                :update="vue_universal_table.update"
                :fields="vue_universal_table.fields"
                :special_buttons="['exportToXlsx']"
                :process_data="vue_universal_table.process_data"
                :export_config="vue_universal_table.export_config"
                :infinite_scroll="true"

                sort_order="DESC"
                sort_by="tanggal_dokumen"
                style="font: normal normal normal 12px/18px Poppins;"
            ></vue-universal-table>

        </div>
        <!-- Table End -->
    </div>
</template>

<script>
    import moment from 'moment'
    import debounce from 'debounce';

    export default {
        metaInfo : {
            title : 'Report'
        },
        data () {
            let startDate = moment().startOf('day').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input mpm--transporter--flatpickr'
                },
                options : {
                    nopol : [],
                    // nopolTemp : 
                },
                selected : {
                    dateButtonsIndex : 2,
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    start : startDate,
                    end : currentDate,
                    search : null,
                },
                vue_universal_table : {
                    export_config : {
                        name : 'Report Download',
                        type : 'xlsx',
                        all : true,
                    },
                    fields : [
                        {title:"Ekspedisi", variable:"ekspedisi"},
                        {title:"NOPOL", variable:"nopol"},
                        {title:"DRIVER", variable:"driver"},
                        {title:"NO TO", variable:"no_to"},
                        {title:"TANGGAL TO", variable:"tanggal_dokumen"},
                        // {title:"Kode Rute", variable:"no_referensi"},
                        {title:"Total Dealer", variable:"jumlah_dealer"},
                        {title:"Terkirim", variable:"jumlah_sl_terkirim"},
                        {title:"Dealer Terluar", variable:"jumlah_titik_terjauh"},
                        // {title:"Ongkos Kirim", variable:"titik_terjauh"},
                    ],
                    update : 0,
                },
                debounceFunction : null
            }
        },
        mounted () {
            // this.fetchNopolOptions();
            this.debounceFunction = debounce((query) => {
                this.options.nopol = ['Loading.....']

                this.fetchNopolOptions(query)
            }, 
            1000)
        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];
                
                this.updateDebounceData();
            },
        },
        methods : {
            fetchNopolOptions (query) {
                this.$http.get(`/api/settings/get-nopol`)
                .then((resp)=>{
                    // this.options.nopol = resp.data.data;
                    let data = resp.data.data.filter(x => x.nopol.toLowerCase().includes(query.toLowerCase()))
                    this.$set(this.options , 'nopol' , data)
                })
                .catch((err)=>{console.log(err)});
            },
            updateDebounceData: debounce(function () {
                this.vue_universal_table.update++
            }, 1500),
        }
    }
</script>

<style>
.no-caret .multiselect__select:before {
    border-color : transparent;
}

.elegant-multiselect {
    border: 1px solid #d5dbe0;
    box-shadow: none;
    font: normal normal normal 16px/25px Poppins
}

.multiselect__placeholder {
    font: normal normal normal 16px/25px Poppins;
    color: #2d353c !important;
    font-weight: 400 !important;
}
</style>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>